export const skyWalkerStyle = { 
  marginTop: '30px',
  marginBottom: '30px',
  flex: 1,
  backgroundColor: 'rgb(255,255,255)',
  padding: '3rem 2rem',
  borderRadius: '0.6rem'
}